import { combineReducers } from 'redux';
import apiCache from './modules/api/cache/reducer';
import apiLoadingIndicator from './modules/api/loadingIndicator/reducer';
import apiRequestsInProgress from './modules/api/requestsInProgress/reducer';
import cookies from './modules/settings/cookies/reducer';
import remoteConfig from './modules/settings/remoteConfig/reducer';
import language from './modules/settings/language/reducer';
import headers from './modules/settings/headers/reducer';
import session from './modules/session/reducer';
import translation from './modules/translation/reducer';
import toast from './modules/toast/reducer';
import dynamicLabels from './modules/dynamicLabels/reducer';
import paymentType from './modules/paymentType/reducer';
import timestamp from './modules/timestamp/reducer';
import bills from './modules/bills/reducer';
import numbers from './modules/numbers/reducer';
import fbbPlans from './modules/fbbPlans/reducer';
import selectedAccount from './modules/addServices/reducer';
import appConfig from './modules/settings/appConfig/reducer';

export default combineReducers({
	api: combineReducers({
		cache: apiCache,
		requestsInProgress: apiRequestsInProgress,
		loadingIndicator: apiLoadingIndicator,
	}),
	settings: combineReducers({
		language,
		cookies,
		remoteConfig,
		headers,
		appConfig,
	}),
	session,
	translation,
	toast,
	paymentType,
	timestamp,
	bills,
	numbers,
	fbbPlans,
	selectedAccount,
	dynamicLabels,
});
